import { tv } from 'tailwind-variants';

const carouselSlideStyles = tv({
    slots: {
        base: "",
        group: `
      iris:relative 
      iris:w-full 
      iris:min-w-0 
      iris:flex-none
    `,
        grid: `
      iris:grid 
      iris:h-full
    `,
        slide: "",
    },
    variants: {
        isMultipleItems: {
            true: {},
        },
        isDesktopSingleItem: {
            true: {
                slide: ``,
            },
        },
        animation: {
            fade: {},
            scroll: {
                slide: `iris:flex-none`,
            },
        },
    },
    compoundVariants: [
        {
            animation: "fade",
            isMultipleItems: true,
            class: {
                grid: `iris:gap-(--comp-space-gap-carousel-item)`,
            },
        },
        {
            positon: "over",
            direction: "right",
            class: `iris:right-4`,
        },
    ],
    defaultVariants: {},
});

export { carouselSlideStyles, carouselSlideStyles as default };
